<script>
import TourMagItem from '@/modules/Tour/Client/Item';
import TourItemComponent from '@/modules/Tour/Client/Item/component.vue';

export default {
  components: {
    TourItemComponent,
  },
  props: {
    id: String,
  },
  data: () => ({
    title: 'Туры: Корзина',
    module: new TourMagItem(),
  }),
  methods: {
    success(data) {
      window.location.href = `/tourclient/admin/orders/info.html?code=${encodeURIComponent(data.agreementCode)}`;
    },
  },
};

</script>
<template>
  <TemplateItem
    :title="title"
    :loading="module.loading"
    wrap
  >
    <router-link
      slot="header-btn"
      to="/tour">
      <BtnPrimary>Вернуться к поиску</BtnPrimary>
    </router-link>
    <TourItemComponent
      :module="module"
      :id="id"
      @success="success"
      :is-auth="true"
      link="/tour"
    />
  </TemplateItem>
</template>
